import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPercentMask]'
})
export class PercentMaskDirective {
  // Opt-out do sufixo " %" aplicado no blur (telas que já indicam o "%" no rótulo).
  @Input() appPercentSuffix = true;
  // Opt-in: aceita o percentual como digitado, com vírgula decimal ("1,5" = 1,50). Sem ele, a máscara
  // empurra os dígitos da direita para a esquerda, como valor monetário ("150" = 1,50).
  @Input() appPercentDecimal = false;

  constructor(private elementRef: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (this.appPercentDecimal) {
      this.onDecimalInput(value);
      return;
    }
    let digits = value.replace(/\D/g, '');
    if (!digits) {
      this.control.control?.setValue('');
      return;
    }
    if (digits.length > 5) {
      digits = digits.substring(0, 5);
    }
    while (digits.length < 3) {
      digits = '0' + digits;
    }
    let intPart = digits.slice(0, digits.length - 2);
    let decPart = digits.slice(-2);
    let formatted = parseInt(intPart, 10) + ',' + decPart;
    let numericValue = parseFloat(formatted.replace(',', '.'));
    if (numericValue > 100) {
      formatted = '100,00';
    }
    this.control.control?.setValue(formatted);
  }

  // Mantém só dígitos e a primeira vírgula (ponto vale como vírgula), até 3 inteiros e 2 decimais.
  private onDecimalInput(value: string) {
    const normalized = value.replace(/\./g, ',').replace(/[^0-9,]/g, '');
    const commaIndex = normalized.indexOf(',');
    let intPart = commaIndex < 0 ? normalized : normalized.slice(0, commaIndex);
    intPart = intPart.substring(0, 3);
    let formatted = intPart;
    if (commaIndex >= 0) {
      const decPart = normalized.slice(commaIndex + 1).replace(/,/g, '').substring(0, 2);
      formatted = (intPart || '0') + ',' + decPart;
    }
    if (parseFloat(formatted.replace(',', '.')) > 100) {
      formatted = '100,00';
    }
    if (formatted !== value) {
      this.elementRef.nativeElement.value = formatted;
    }
    this.control.control?.setValue(formatted, { emitModelToViewChange: false });
  }

  @HostListener('blur')
  onBlur() {
    let value = this.control.control?.value;
    if (!value) return;
    let numericValue = parseFloat(
      value.replace(/[^0-9,]/g, '').replace(',', '.')
    );
    if (isNaN(numericValue)) {
      this.control.control?.setValue('');
      return;
    }
    if (numericValue > 100) numericValue = 100;
    let formatted = numericValue.toFixed(2).replace('.', ',') + (this.appPercentSuffix ? ' %' : '');
    this.control.control?.setValue(formatted);
  }
}
